define('commons/flat-tree-role',['jquery', 'commons/flat-tree'], function($, FlatTree) {
    
    var FlatTreeRole = function(containerSelector, options) {
        FlatTree.call(this, containerSelector, $.extend({
            loadItemUrl: '/role/json/list'
        }, options));
    };
    
    // Inherit from FlatTree
    for (var element in FlatTree.prototype) {
        FlatTreeRole.prototype[element] = FlatTree.prototype[element];
    }
    
    return FlatTreeRole;
    
});
